import { DataSourceReferenceBase } from "abweb/dto/generated/ds/DataSourceReferenceBase";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { ReferenceTuple } from "abweb/dto/ds/ReferenceTuple";
import { DataSourceValue } from "abweb/dto/ds/DataSourceValue";
import { DateTimeUtils } from "abweb/utils/date/DateTimeUtils";
import { NumberUtils } from "abweb/utils/NumberUtils";
import { ClassUtils } from "abweb/utils/ClassUtils";
export class DataSourceReference extends DataSourceReferenceBase {
  /**
   * Simplified factory method for creating a DataSourceReference in a NORMAL state with no baseline.
   * @param id
   * @param value
   * @param displayValue
   * @param refID
   * @returns {DataSourceReference}
   */
  static createWithReadOnlyDefaults(id, value, displayValue, refID) {
    return DataSourceReference.createDataSourceReference(/*attributeValues*/null, /*clientTag*/null, /*dataSourceSaveAction*/null, id, /*baselineRefID*/null, refID, /*state*/DataSourceState.NORMAL, /*baseline*/null, /*displayBaseline*/null, displayValue, value, /*editableOverwrite*/null, /*fieldTypeOverwrite*/null);
  }
  static createDataSourceReference(attributeValues, clientTag, dataSourceSaveAction, id, baselineRefID, refID, state, baseline, displayBaseline, displayValue, value, editableOverwrite = null, fieldTypeOverwrite = null) {
    const retVal = new DataSourceReference();
    let baselineRef = null;
    if (baseline) {
      baselineRef = new ReferenceTuple();
      baselineRef.value = baseline;
      baselineRef.displayValue = displayBaseline;
    }
    const valueRef = new ReferenceTuple();
    valueRef.value = value;
    valueRef.displayValue = displayValue;
    retVal.initDataSourceReference(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baselineRef, /*currentValue*/null, valueRef);
    return retVal;
  }
  constructor() {
    super();
  }
  initDataSourceReference(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baselineRef, currentValueRef, valueRef) {
    super.initDataSourceReference(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baselineRef, currentValueRef, valueRef);
    if (currentValueRef == null) {
      this.currentValue = new ReferenceTuple();
      this.currentValue.value = valueRef.value;
      this.currentValue.displayValue = valueRef.displayValue;
    }
  }
  get hasRef() {
    // A value of this type is ALWAYS considered a reference (even if it may not have a refID (cause it might be new))
    return true;
  }
  getCurrentValue() {
    return this.currentValue;
  }
  getValue() {
    return this.valueRef;
  }
  getBaseline() {
    return this.baselineRef;
  }
  getDisplayValue() {
    const tuple = this.get("currentValue");
    return this.getFormattedValue(tuple);
  }
  getCanonicalEditValue() {
    const tuple = this.get("currentValue");
    if (tuple == null) {
      return null;
    }
    return tuple.value;
  }
  getFormattedValue(value) {
    if (value == null) {
      return "";
    }
    const ref = value;
    return ref.displayValue ? ref.displayValue : "";
  }
  areEqual(value1, value2) {
    // For a REFERENCE type equality is based on comparing OIDs, unless both don't have OIDs, in which case
    if (value1 == null && value2 == null) {
      return true;
    }
    if (value1 == null || value2 == null) {
      return false;
    }
    const tuple1 = value1;
    const tuple2 = value2;
    return tuple1.value === tuple2.value && tuple1.displayValue === tuple2.displayValue;
  }
  get isReference() {
    return true;
  }
  isEmpty() {
    if (super.isEmpty()) {
      return true;
    }
    return this.refID == null;
  }
  get refID() {
    if (this.currentValue == null) {
      return null;
    }
    return this.currentValue.value;
  }
  set refID(value) {
    if (value === this.refID) {
      return;
    }
    const tuple = ReferenceTuple.createReferenceTuple(this.getDisplayValue(), value);
    this.set("currentValue", tuple);
  }
  coerceValue(value) {
    // Note that for a reference type, we will coerce this to a ReferenceTuple
    const tuple = ReferenceTuple.createReferenceTuple(null, null);
    if (value == null) {
      return tuple;
    }
    if (ClassUtils.isInstanceOf(value, ReferenceTuple)) {
      tuple.displayValue = value.displayValue;
      tuple.value = value.value;
      return tuple;
    }
    if (ClassUtils.isInstanceOf(value, DataSourceValue)) {
      if (value.isReference || value.refID != null) {
        tuple.displayValue = value.getDisplayValue();
        tuple.value = value.refID;
        return tuple;
      }

      // Assume we want to set the value only
      value = value.getCurrentValue();
    }

    // Use our current value of displayValue, we're only going to change value
    tuple.displayValue = this.getDisplayValue();
    if (value == null) {
      return tuple;
    }

    // Convert the value to a string and use it as the value.
    const t = typeof value;
    if (t === "string") {
      tuple.value = value;
    } else if (t === "number") {
      tuple.value = NumberUtils.formatValue(value);
    } else if (ClassUtils.isInstanceOf(value, Date)) {
      tuple.value = DateTimeUtils.DATE_SHORT.format(value);
    } else {
      tuple.value = value.toString();
    }
    return tuple;
  }
}
//# sourceMappingURL=DataSourceReference.js.map
